import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import NeuralCanvas from '../../components/NeuralCanvas';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import './About.css';

// Componente para el skeleton loader
const SkeletonLoader = () => (
  <div className="skeleton-container">
    <div className="skeleton-header"></div>
    <div className="skeleton-section">
      <div className="skeleton-title"></div>
      <div className="skeleton-text"></div>
      <div className="skeleton-text"></div>
    </div>
    <div className="skeleton-button"></div>
  </div>
);

const About = () => {
  const { t, ready } = useTranslation();
  
  // Aseguramos que se pueda hacer scroll
  useEffect(() => {
    // Resetear cualquier restricción de scroll
    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';
    
    return () => {
      // Limpiar al desmontar
      document.body.style.overflow = '';
      document.body.style.height = '';
    };
  }, []);

  // Si las traducciones no están listas, mostramos el skeleton
  if (!ready) {
    return (
      <div className="about-wrapper">
        <div className="overlay"></div>
        <NeuralCanvas />
        <div className="about-container">
          <SkeletonLoader />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="overlay"></div>
      <NeuralCanvas />
      
      {/* Selector de idioma */}
      <div className="language-selector-container">
        <LanguageSelector />
      </div>
      
      {/* Botón para volver a la página principal */}
      <div className="button-container">
        <a href="/" className="back-button">
          {t('common.home')}
        </a>
      </div>
      
      <main className="about-wrapper">
        <div className="about-container">
          <div className="about-header">
            <h1>{t('about.title')}</h1>
          </div>
          
          <div className="about-content">
            <section className="about-section">
              <p>{t('about.description')}</p>
            </section>
          </div>
        </div>
      </main>
    </>
  );
};

export default About; 